module.exports = __webpack_public_path__ + "static/media/cog-solid.9f07a3df.svg";